import classNames from 'classnames'
import { motion, useReducedMotion } from 'framer-motion'
import { Easing } from 'motion'
import { PropsWithChildren } from 'react'

import styles from './BaseField.module.scss'

interface Props extends PropsWithChildren {
  hasHint?: boolean
}

export const BaseFieldAnimation: React.FC<Props> = (props) => {
  const { hasHint, children } = props
  const prefersReducedMotion = useReducedMotion()
  const EASE_OUT: Easing = [0.22, 1, 0.36, 1]

  return (
    <motion.div
      key='hint'
      className={classNames(styles.hintMotion, { [styles.visible]: hasHint })}
      initial={
        prefersReducedMotion
          ? { opacity: 1, maxHeight: 999, paddingTop: 4 }
          : { opacity: 0, maxHeight: 0, paddingTop: 0, y: -4 }
      }
      animate={{ opacity: 1, maxHeight: 80, paddingTop: 4, y: 0 }}
      exit={{ opacity: 0, maxHeight: 0, paddingTop: 0, y: -4 }}
      transition={{
        maxHeight: { duration: 0.2, ease: EASE_OUT },
        paddingTop: { duration: 0.2, ease: EASE_OUT },
        opacity: { duration: 0.12, ease: EASE_OUT },
        y: { duration: 0.12, ease: EASE_OUT },
      }}
    >
      {children}
    </motion.div>
  )
}
